import React from "react";
import { IconProps } from "@/components/Icon";
interface PhoneIconProps extends Omit<IconProps, "children"> {}

export const PhoneIcon = ({ ...props }: PhoneIconProps) => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.98356 7.3777C7.56356 8.58572 8.35422 9.71792 9.35553 10.7192C10.3568 11.7206 11.4891 12.5112 12.6971 13.0912C12.801 13.1411 12.8529 13.166 12.9187 13.1852C13.1523 13.2533 13.4392 13.2044 13.637 13.0627C13.6927 13.0228 13.7403 12.9752 13.8356 12.88C14.1269 12.5886 14.2726 12.4429 14.4191 12.3477C14.9715 11.9885 15.6837 11.9885 16.2361 12.3477C16.3825 12.4429 16.5282 12.5886 16.8196 12.88L16.9819 13.0423C17.4248 13.4852 17.6462 13.7066 17.7665 13.9445C18.0058 14.4174 18.0058 14.976 17.7665 15.449C17.6462 15.6868 17.4248 15.9082 16.9819 16.3511L16.8506 16.4824C16.4092 16.9238 16.1886 17.1445 15.8885 17.313C15.5556 17.5 15.0385 17.6345 14.6567 17.6334C14.3126 17.6323 14.0774 17.5656 13.607 17.4321C11.0792 16.7146 8.69387 15.3609 6.70388 13.3709C4.7139 11.3809 3.36017 8.9956 2.6427 6.46777C2.50919 5.9974 2.44244 5.76221 2.44141 5.41809C2.44028 5.03624 2.57475 4.51916 2.76176 4.18624C2.9303 3.88621 3.15098 3.66554 3.59233 3.22419L3.72369 3.09282C4.16656 2.64996 4.388 2.42852 4.62581 2.30823C5.09878 2.06901 5.65734 2.06901 6.1303 2.30823C6.36812 2.42852 6.58955 2.64995 7.03242 3.09282L7.19481 3.25521C7.48615 3.54655 7.63182 3.69222 7.72706 3.8387C8.08622 4.39111 8.08622 5.10326 7.72706 5.65567C7.63182 5.80215 7.48615 5.94782 7.19482 6.23916C7.09955 6.33442 7.05193 6.38205 7.01206 6.43773C6.87038 6.63559 6.82146 6.92247 6.88957 7.1561C6.90873 7.22184 6.93368 7.27379 6.98356 7.3777Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
